"use client"
import React, { useState } from 'react';
import { Button, ButtonStyle, Drawer, DVIcon, FormGroup, Switcher } from '@develos/next-components';
import { usePropertyUpdate } from '@/store';
import { selectParametersExceededFilterMode, selectWeightLimitFilterMode, setParametersExceededFilterMode, setWeightLimitFilterMode, VehicleParametersExceedeFilterMode, VehicleWeightLimitFilterMode } from '@/store/portalSettings';
import { useUpdateUserSettingsMutation } from "@/store/portalSettings/api";

const PortalSettingsHeaderDropdown = () => {
  const [ isVisible, setIsVisible ] = useState(false);
  const { 
    updateStoreProp: updateParametersExceededFilterMode,
    propertyValue: parametersExceededFilterMode
  } = usePropertyUpdate(setParametersExceededFilterMode, selectParametersExceededFilterMode);
  const {
    updateStoreProp: updateWeightLimitFilterMode,
    propertyValue: weightLimitFilterMode
  } = usePropertyUpdate(setWeightLimitFilterMode, selectWeightLimitFilterMode);

  const [updateUserSettings] = useUpdateUserSettingsMutation();

  const handleClose = async () => {
    const settings = JSON.stringify({
      parametersExceededFilterMode,
      weightLimitFilterMode
    });
      await updateUserSettings({ settings }).unwrap();
      setIsVisible(false);
  };

  return (
    <div className="rm-flex rm-items-center">
      <Button
        style={ButtonStyle.IconOnly}
        dataTestId="portlsettings-header-dropdown"
        handleClick={() => setIsVisible(!isVisible)}
      >
        <DVIcon name="Settings" className='rm-h-4 rm-w-4 rm-text-gray-600'/>
      </Button>
      <Drawer
        dataTestId='create-new-user-drawer'
        isOpen={isVisible}
        labels={{
          cancelButton: "Zamknij"
        }}
        header={"Ustawienia aplikacji"}
        description={"Zdefiniuj opcje działania aplikacji. Wybierz czy i w jaki sposób chcesz filtorwać pojazdy w aplikacji w podglądzie Live oraz Historii"}
        onClose={handleClose}
      >
        <FormGroup.Wrapper>
          <FormGroup 
            label="Rodzaje pojazdów"
          >
            <Switcher
              value={weightLimitFilterMode}
              onChange={updateWeightLimitFilterMode}
              options={[
                { value: VehicleWeightLimitFilterMode.All, label: "Wszystkie", icon: "CarFront" },
                { value: VehicleWeightLimitFilterMode.Above35Ton, label: "Powyżej 3,5 tony", icon: "Truck" },
              ]}
            />
          </FormGroup>
          <FormGroup 
            label="Pojazdy z przekroczonym parametrem"
          >
            <Switcher
              value={parametersExceededFilterMode}
              onChange={updateParametersExceededFilterMode}
              options={[
                { value: VehicleParametersExceedeFilterMode.All, label: "Nieaktywny", icon: "ShieldCheck" },
                { value: VehicleParametersExceedeFilterMode.OnlyWithExceededParameter, label: "Aktywny", icon: "ShieldAlert" },
              ]}
            />
          </FormGroup>
        </FormGroup.Wrapper>
      </Drawer> 
    </div>
  );
};

export default PortalSettingsHeaderDropdown;
